import React from "react";
import ReactDOM from "react-dom";
import { Router, Route,Redirect,Switch } from "react-router-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import reduxThunk from "redux-thunk";
import { renderRoutes } from 'react-router-config';
import registerServiceWorker from "./registerServiceWorker";
import App from "./components/App";
import reducers from "./reducers";
import history from "./utils/history";
import routes from './routes';

ReactDOM.render(
  <Provider store={createStore(reducers, {}, applyMiddleware(reduxThunk))}>
    <Router history={history}>
      <App>
        {renderRoutes(routes)}
      </App>
    </Router>
  </Provider>,
  document.querySelector("#root")
);
registerServiceWorker();
